import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import { Container } from "@mui/material";
import TopBar from "./TopBar";
import { ColorModeContext } from "../context/ColorModeContext"; // Import the ColorModeContext

const Layout = () => {
  const { mode } = useContext(ColorModeContext); // Get the current mode from context

  // Set the background image based on the theme mode
  const backgroundImage =
    mode === "light"
      ? `${process.env.PUBLIC_URL}/img/logos/minervalight-background.png` // Light mode image
      : `${process.env.PUBLIC_URL}/img/logos/minervadark-background.png`; // Dark mode image

  return (
    <div>
      <TopBar />
      <Container
        sx={{
          mt: 2,
          backgroundImage: `url(${backgroundImage})`, // Use the selected background image
          backgroundSize: "50%", // Adjust size as needed
          backgroundPosition: "top left", // Adjust position as needed
          backgroundRepeat: "no-repeat", // Prevent repeating
          pt: 4, // Optional padding for content
        }}
      >
        <Outlet />
      </Container>
    </div>
  );
};

export default Layout;
